export const footerContainer =
  " py-3 bg-[#F2F2F2] font-semibold dark:bg-[#1B1A1A] dark:text-white";

export const footerBox = "container mx-auto p-4 ";

export const footerBody = "flex flex-col justify-center items-center gap-2";

export const footerImage = "scale-[1.3]";
